module.exports = "../fonts/ApercuLAPhil-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Bold.woff
// module id = 510
// module chunks = 7